import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { ContractService } from '@manager-app/storage/service/contract.service';
import { ContractModel, extractNumber, HxUiLabelPipe, OrganizationModel, toRouterQueryParams } from 'hx-services';
import { NgbModal, NgbPagination, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { ContractNewComponent } from '../new/contract-new.component';
import { OrganizationSelectComponent } from '../../../components/organization-select/organization-select.component';
import { HxDateSelectComponent, HxLoaderComponent } from 'hx-component';
import { SuppliersSearchComponent } from '../../../components/suppliers-search/suppliers-search.component';
import { DatePipe, NgClass, NgFor, NgIf } from '@angular/common';

/**
 * Component show list of contracts
 */
@Component({
    selector: 'app-contract-list.m-grid__item.m-grid__item--fluid.m-wrapper',
    templateUrl: './contract-list.component.html',
    styleUrls: ['./contract-list.component.css'],
    imports: [ContractNewComponent, OrganizationSelectComponent, FormsModule, HxDateSelectComponent, SuppliersSearchComponent, NgbTooltip, NgIf, NgFor, NgClass, RouterLink, HxLoaderComponent, NgbPagination, DatePipe, TranslocoPipe, HxUiLabelPipe]
})
export class ContractListComponent implements OnInit, OnDestroy {
  @ViewChild('templateRef') public templateRef: TemplateRef<any>;
  list: ContractModel[] = [];
  pagination = {
    currentPage: 1,
    allItemCount: 0,
    limit: 20,
    maxPage: 1
  };
  contractId: number;
  isLoading = {
    list: false,
  };
  selectedContract: ContractModel;
  contractForm: UntypedFormGroup;
  myOrganizations: OrganizationModel[] = [];
  params: {
    page?: number;
    date?: string;
    number?: string;
    organizationId?: number;
    supplierId?: number;
  } = {page: 1};
  private sub: Subscription;

  constructor(
    private contractService: ContractService,
    private toastr: HcToastrService,
    private router: Router,
    private aRoute: ActivatedRoute,
    private modal: NgbModal,
    private fb: UntypedFormBuilder,
    private tr: TranslocoService
  ) {
  }

  ngOnInit() {
    this.contractForm = this.fb.group({supplierId: [null]});
    this.sub = this.aRoute.queryParamMap.subscribe(paramMap => {
      this.params.page = extractNumber('page', paramMap) ?? 1;
      this.params.organizationId = extractNumber('organizationId', paramMap);
      this.params.supplierId = extractNumber('supplierId', paramMap);
      this.params.number = paramMap.get('number');
      this.params.date = paramMap.get('date');
      this.getList();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onContractSaved(saved) {
    this.contractId = null;
    if (saved) {
      this.params = {page: 1};
      this.getList();
    }
  }

  updateItem(item) {
    this.contractId = item.id;
  }

  pageChanged(event: number) {
    this.params.page = event;
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }

  async deleteItem(id) {
    try {
      await this.contractService.deleteContract(id);
      this.modal.dismissAll();
      this.toastr.success(this.tr.translate('contract-list.ts.treatyDelete'));
      this.getList();
    } catch (e) {
      this.toastr.error(this.tr.translate('contract-list.ts.error'));
    }
  }
  confirmModal(contract: ContractModel) {
    this.selectedContract = contract;
    this.modal.open(this.templateRef, { size: 'medium', centered: true });
  }

  resetFilter() {
    this.params = {page: 1};
    this.contractForm.reset();
    this.pageChanged(1);
  }

  applyFilters() {
    this.pageChanged(1);
  }

  private async getList() {
    this.list = [];
    this.isLoading.list = true;
    try {
      const result = await this.contractService.getContractList(this.params);
      this.list = result.list || [];
      this.pagination.allItemCount = result.count;
    } finally {
      this.isLoading.list = false;
    }
  }
}
